import { messaging, getToken } from '../lib/firebase';
import request from '../lib/request';
import config from '../config';

async function requestPermissionAndGetToken() {
  try {
    const status = await Notification.requestPermission();
    if (messaging && status === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: config.fcm.vapidKey,
      });

      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      let device = '';

      if (/android/i.test(userAgent)) {
        device = 'AOS';
      }

      // iOS detection for Safari, Chrome, and other browsers on iPhone/iPad
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        device = 'IOS';
      }

      const localToken = window.localStorage.getItem('fcmToken');
      if (localToken !== token) {
        const { result } = await request.post('/user/device-token', {
          oldToken: localToken || null,
          newToken: token,
          device,
        });
        if (result?.token) {
          window.localStorage.setItem('fcmToken', result.token);
        }
      }

      await request.put('/user/notification', {
        appPush: true,
      });
    } else {
      console.warn('Notification permission denied.');
    }
  } catch (err) {
    console.error('Error getting FCM token:', err);
  }
}

const useFirebase = (user) => {
  if (user && window.matchMedia('(display-mode: standalone)').matches) {
    requestPermissionAndGetToken();
  }
};

export default useFirebase;
